export const PLAYED = "PLAYED";

export const SET_ONLINE_PLAYERS = "SET_ONLINE_PLAYERS";
export const SET_PLAYERS = "SET_PLAYERS";
export const SET_WINNER = "SET_WINNER";

export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const SET_LEADERBOARD = "SET_LEADERBOARD";
export const LEADERBOARD_START = "LEADERBOARD_START";
export const LEADERBOARD_FAILED = "LEADERBOARD_FAILED";
export const SET_BOARD_SIZE = "SET_BOARD_SIZE";